import React, { useEffect, useState } from 'react';
import axios from "../../config/axios";
import SearchBar from './SearchBar';
import { Box, Grid } from '@mui/material';
import Calendar from "./Calendar";
import AddNewsEvents from "./AddNewsEvents";
import Content from "./Content";
import { ThemeProvider } from '@mui/material/styles';
import theme from '../../style/theme';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useTranslation } from 'react-i18next';

import './NewsEvents.css';

dayjs.extend(utc);
dayjs.extend(timezone);

const NewsEvents = () => {
    const { t } = useTranslation();
    const token = localStorage.getItem('AUTHORIZATION_TOKEN_BLOG');
    const user = JSON.parse(localStorage.getItem('user'));

    const [events, setEvents] = useState([]);
    const [eventItems, setEventItems] = useState([]);
    const [eventParticipants, setEventParticipants] = useState([]);
    const [eventParticipantItems, setEventParticipantItems] = useState([]);
    const [eventThumbnails, setEventThumbnails] = useState([]);
    const [eventFiles, setEventFiles] = useState([]);

    const [news, setNews] = useState([]);
    const [newsThumbnails, setNewsThumbnails] = useState([]);

    const [loading, setLoading] = useState(true);

    const [loadingEveryEvents, setLoadingEveryEvents] = useState(true);
    const [loadingEvents, setLoadingEvents] = useState(true);
    const [loadingEventParticipants, setLoadingEventParticipants] = useState(true);
    const [loadingEventItems, setLoadingEventItems] = useState(true);
    const [loadingEventParticipantItems, setLoadingEventParticipantItems] = useState(true);
    const [loadingEventThumbnails, setLoadingEventThumbnails] = useState(true);
    const [loadingEventFiles, setLoadingEventFiles] = useState(true);

    const [loadingEveryNews, setLoadingEveryNews] = useState(true);
    const [loadingNews, setLoadingNews] = useState(true);
    const [loadingNewsThumbnails, setLoadingNewsThumbnails] = useState(true);

    const [date, setDate] = useState(dayjs(Date.now()));
    const [selectedDate, setSelectedDate] = useState(null);

    const [searchTerm, setSearchTerm] = useState('');

    const handleDateSelect = (newDate) => {
        // If clicking the same date, clear the filter
        if (selectedDate && newDate.isSame(selectedDate, 'day')) {
            setSelectedDate(null);
        } else {
            setSelectedDate(newDate);
        }
    };

    const clearSelectedDate = () => {
        setSelectedDate(null);
    };

    const getEvents = () => {
        if (searchTerm) {
            const keyword = searchTerm;
            axios.get('/event/search', {
                params: {
                    limit: 100,
                    page: 1,
                    keyword: keyword
                }
            })
                .then((response) => {
                    const eventsData = Array.isArray(response.data) ? response.data : [];
                    setEvents(eventsData);

                    const eventItems = eventsData.map(event => {
                        return axios.get(`/event/${event.id}/item`, {
                            params: {
                                limit: 100,
                                page: 1,
                            }
                        })
                            .then(response => response.data)
                            .catch(error => {
                                console.error(error);
                            });
                    });
                    setLoadingEvents(false);

                    return Promise.all(eventItems)
                }).then(eventItems => {
                    setEventItems(eventItems);
                    setLoadingEventItems(false);
                })
                .catch(error => {
                    console.error(error);
                });

            axios.get('/event/search', {
                params: {
                    limit: 100,
                    page: 1,
                    keyword: keyword
                }
            })
                .then((response) => {
                    const eventsData = Array.isArray(response.data) ? response.data : [];
                    const eventThumbnails = eventsData.map(event => {
                        return axios.get(`/event/thumbnail/${event.id}`, {
                            responseType: 'blob'
                        })
                            .then(response => URL.createObjectURL(response.data))
                            .catch(error => {
                                console.error(error);
                            });
                    });
                    return Promise.all(eventThumbnails)
                }).then(eventThumbnails => {
                    setEventThumbnails(eventThumbnails);
                    setLoadingEventThumbnails(false);
                })
                .catch(error => {
                    console.error(error);
                });

            axios.get('/event/search', {
                params: {
                    limit: 100,
                    page: 1,
                    keyword: keyword
                }
            })
                .then((response) => {
                    const eventsData = Array.isArray(response.data) ? response.data : [];
                    const eventFiles = eventsData.map(event => {
                        return axios.get(`/event/file/${event.id}`, {
                            responseType: 'blob'
                        })
                            .then(response => URL.createObjectURL(response.data))
                            .catch(error => {
                                console.error(error);
                            });
                    });
                    return Promise.all(eventFiles)
                }).then(eventFiles => {
                    setEventFiles(eventFiles);
                    setLoadingEventFiles(false);
                })
                .catch(error => {
                    console.error(error);
                });

            if (user?.authRole === 'admin') {
                axios.get('/event/search', {
                    params: {
                        limit: 100,
                        page: 1,
                        keyword: keyword
                    }
                })
                    .then((response) => {
                        const eventsData = Array.isArray(response.data) ? response.data : [];
                        const eventParticipants = eventsData.map(event => {
                            return axios.get(`/event/${event.id}/participant`, {
                                params: {
                                    limit: 100,
                                    page: 1,
                                },
                                headers: {
                                    token: token
                                }
                            })
                                .then(response => response.data)
                                .catch(error => {
                                    console.error(error);
                                });
                        });
                        return Promise.all(eventParticipants);
                    }).then(eventParticipants => {
                        setEventParticipants(eventParticipants);
                        setLoadingEventParticipants(false);
                    })
                    .catch(error => {
                        console.error(error);
                    });

                axios.get('/event/participant/item', {
                    params: {
                        limit: 100,
                        page: 1,
                    },
                    headers: {
                        token: token
                    }
                })
                    .then((response) => {
                        const data = Array.isArray(response.data) ? response.data : [];
                        setEventParticipantItems(data);
                        setLoadingEventParticipantItems(false);
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        } else {
            axios.get('/event', {
                params: {
                    limit: 100,
                    page: 1,
                }
            })
                .then((response) => {
                    const eventsData = Array.isArray(response.data) ? response.data : [];
                    setEvents(eventsData);

                    const eventItems = eventsData.map(event => {
                        return axios.get(`/event/${event.id}/item`, {
                            params: {
                                limit: 100,
                                page: 1,
                            }
                        })
                            .then(response => response.data)
                            .catch(error => {
                                console.error(error);
                            });
                    });
                    setLoadingEvents(false);

                    return Promise.all(eventItems)
                }).then(eventItems => {
                    setEventItems(eventItems);
                    setLoadingEventItems(false);
                })
                .catch(error => {
                    console.error(error);
                });

            axios.get('/event', {
                params: {
                    limit: 100,
                    page: 1,
                }
            })
                .then((response) => {
                    const eventsData = Array.isArray(response.data) ? response.data : [];
                    const eventThumbnails = eventsData.map(event => {
                        return axios.get(`/event/thumbnail/${event.id}`, {
                            responseType: 'blob'
                        })
                            .then(response => URL.createObjectURL(response.data))
                            .catch(error => {
                                console.error(error);
                            });
                    });
                    return Promise.all(eventThumbnails)
                }).then(eventThumbnails => {
                    setEventThumbnails(eventThumbnails);
                    setLoadingEventThumbnails(false);
                })
                .catch(error => {
                    console.error(error);
                });

            axios.get('/event', {
                params: {
                    limit: 100,
                    page: 1,
                }
            })
                .then((response) => {
                    const eventsData = Array.isArray(response.data) ? response.data : [];
                    const eventFiles = eventsData.map(event => {
                        return axios.get(`/event/file/${event.id}`, {
                            responseType: 'blob'
                        })
                            .then(response => URL.createObjectURL(response.data))
                            .catch(error => {
                                console.error(error);
                            });
                    });
                    return Promise.all(eventFiles)
                }).then(eventFiles => {
                    setEventFiles(eventFiles);
                    setLoadingEventFiles(false);
                })
                .catch(error => {
                    console.error(error);
                });

            if (user?.authRole === 'admin') {
                axios.get('/event', {
                    params: {
                        limit: 100,
                        page: 1,
                    }
                })
                    .then((response) => {
                        const eventsData = Array.isArray(response.data) ? response.data : [];
                        const eventParticipants = eventsData.map(event => {
                            return axios.get(`/event/${event.id}/participant`, {
                                params: {
                                    limit: 100,
                                    page: 1,
                                },
                                headers: {
                                    token: token
                                }
                            })
                                .then(response => response.data)
                                .catch(error => {
                                    console.error(error);
                                });
                        });
                        return Promise.all(eventParticipants);
                    }).then(eventParticipants => {
                        setEventParticipants(eventParticipants);
                        setLoadingEventParticipants(false);
                    })
                    .catch(error => {
                        console.error(error);
                    });

                axios.get('/event/participant/item', {
                    params: {
                        limit: 100,
                        page: 1,
                    },
                    headers: {
                        token: token
                    }
                })
                    .then((response) => {
                        const data = Array.isArray(response.data) ? response.data : [];
                        setEventParticipantItems(data);
                        setLoadingEventParticipantItems(false);
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        }
    }

    const getNews = () => {
        if (searchTerm) {
            const keyword = searchTerm;
            axios.get('/news/search', {
                params: {
                    limit: 100,
                    page: 1,
                    keyword: keyword
                }
            }).then((response) => {
                const newsData = Array.isArray(response.data) ? response.data : [];
                setNews(newsData);
                setLoadingNews(false);

                const newsThumbnails = newsData.map((news) => {
                    return axios.get(`/news/thumbnail/${news.id}`, {
                        responseType: 'blob'
                    })
                        .then(response => URL.createObjectURL(response.data))
                        .catch(error => {
                            console.error(error);
                        });
                });

                return Promise.all(newsThumbnails);
            }).then(newsThumbnailArray => {
                setNewsThumbnails(newsThumbnailArray);
                setLoadingNewsThumbnails(false);
            }).catch(error => {
                console.error(error);
            });
        } else {
            axios.get('/news', {
                params: {
                    limit: 100,
                    page: 1,
                }
            }).then((response) => {
                const newsData = Array.isArray(response.data) ? response.data : [];
                setNews(newsData);
                setLoadingNews(false);

                const newsThumbnails = newsData.map((news) => {
                    return axios.get(`/news/thumbnail/${news.id}`, {
                        responseType: 'blob'
                    })
                        .then(response => URL.createObjectURL(response.data))
                        .catch(error => {
                            console.error(error);
                        });
                });

                return Promise.all(newsThumbnails);
            }).then(newsThumbnailArray => {
                setNewsThumbnails(newsThumbnailArray);
                setLoadingNewsThumbnails(false);
            }).catch(error => {
                console.error(error);
            });
        }
    }

    // Refresh functions for after creating new events/news
    const refreshEvents = () => {
        // Reset loading states to trigger data refetch
        setLoadingEvents(true);
        setLoadingEventItems(true);
        setLoadingEventThumbnails(true);
        setLoadingEventFiles(true);
        if (user?.authRole === 'admin') {
            setLoadingEventParticipants(true);
            setLoadingEventParticipantItems(true);
        }
        setLoadingEveryEvents(true);
        // Also directly call getEvents to ensure refresh
        setTimeout(() => getEvents(), 100);
    };

    const refreshNews = () => {
        // Reset loading states to trigger data refetch
        setLoadingNews(true);
        setLoadingNewsThumbnails(true);
        setLoadingEveryNews(true);
        // Also directly call getNews to ensure refresh
        setTimeout(() => getNews(), 100);
    };

    useEffect(() => {
        if (user?.authRole === 'admin') {
            if (!loadingEvents && !loadingEventParticipants && !loadingEventItems && !loadingEventParticipantItems && !loadingEventFiles) {
                setLoadingEveryEvents(false);
            } else {
                getEvents();
            }
        } else {
            if (!loadingEvents && !loadingEventItems && !loadingEventThumbnails && !loadingEventFiles) {
                setLoadingEveryEvents(false);
            } else {
                getEvents();
            }
        }

        if (!loadingNews && !loadingNewsThumbnails) {
            setLoadingEveryNews(false);
        } else {
            getNews();
        }
    }, [searchTerm,
        loadingEvents, loadingEventParticipants, loadingEventParticipantItems, loadingEventItems, loadingEventThumbnails, loadingEventFiles,
        loadingNews, loadingNewsThumbnails
    ]);

    return (
        <ThemeProvider theme={theme}>
            <div className="newsEventsContainer">
                {/* Page Header */}
                <div className="newsEventsHeader">
                    <h1 className="newsEventsTitle">{t('News & Events')}</h1>
                    <p className="newsEventsSubtitle">{t('EventsPage.Stay updated with the latest news and upcoming events')}</p>
                </div>

                {/* Search Bar */}
                <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm}
                    getEvents={getEvents} getNews={getNews}
                />

                {/* Main Layout */}
                <div className="newsEventsMain">
                    {/* Content Area */}
                    <div className="newsEventsContent">
                        <Content axiosEvents={events} axiosEventItems={eventItems}
                            axiosEventParticipants={eventParticipants}
                            axiosEventParticipantItems={eventParticipantItems}
                            axiosEventThumbnails={eventThumbnails}
                            axiosEventFiles={eventFiles}

                            axiosNews={news} axiosNewsThumbnails={newsThumbnails}

                            loadingEvents={loadingEveryEvents}

                            loadingNews={loadingEveryNews}

                            date={date} dayjs={dayjs}
                            selectedDate={selectedDate}
                            clearSelectedDate={clearSelectedDate}

                            token={token} user={user}
                        />
                    </div>

                    {/* Sidebar */}
                    <div className="newsEventsSidebar">
                        <div className="calendarContainer">
                            <Calendar
                                events={events.map((event) => dayjs(event.eventTimestamp))}
                                todaysDate={date}
                                loadingEvents={loadingEveryEvents}
                                onDateSelect={handleDateSelect}
                                selectedDate={selectedDate}
                            />
                        </div>
                        <AddNewsEvents
                            date={date}
                            setDate={setDate}
                            token={token}
                            user={user}
                            onEventCreated={refreshEvents}
                            onNewsCreated={refreshNews}
                        />
                    </div>
                </div>
            </div>
        </ThemeProvider>
    );
};

export default NewsEvents;
